/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const contentTypeDefinitionInputReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const contentTypeDefinitionInputReferenceViewPredicatesMax = 10;

export const contentTypeDefinitionInputReferenceViewSearchTermsItemMax = 200;

export const contentTypeDefinitionInputReferenceViewSearchTermsMax = 10;

export const ContentTypeDefinitionInput = zod.object({
  conformance: zod.enum(['open', 'lax', 'strict']).optional(),
  description: zod.string().nullish(),
  enumOptions: zod
    .array(zod.string().min(1))
    .optional()
    .describe(
      'Ordered choice values for an ENUM type (one string per option). Stored as { value, label } with value === label.',
    ),
  file: zod
    .object({
      allowedFormats: zod
        .array(
          zod.enum([
            'pdf',
            'doc',
            'docx',
            'xls',
            'xlsx',
            'csv',
            'txt',
            'jpeg',
            'png',
            'webp',
            'gif',
            'heic',
            'md',
            'html',
            'mp3',
            'm4a',
            'wav',
            'mp4',
            'mov',
            'webm',
          ]),
        )
        .min(1)
        .optional(),
    })
    .nullish()
    .describe(
      'File config for a STRING type whose instances hold uploaded files. allowedFormats narrows the platform allowlist to a subset of format ids; omitted, the field accepts every platform-supported format. Pass null to clear a stored config; omit to keep it.',
    ),
  reference: zod
    .object({
      carbonCopy: zod.boolean().optional(),
      creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
      edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
      typeLineageUuid: zod.uuid(),
      typeUuid: zod.uuid(),
      view: zod
        .object({
          predicates: zod
            .array(
              zod.object({
                op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                pathTypeUuids: zod
                  .array(zod.uuid())
                  .min(1)
                  .max(contentTypeDefinitionInputReferenceViewPredicatesItemPathTypeUuidsMax),
                value: zod.string().optional(),
                valueType: zod
                  .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                  .optional(),
              }),
            )
            .max(contentTypeDefinitionInputReferenceViewPredicatesMax)
            .optional(),
          searchTerms: zod
            .array(
              zod.string().min(1).max(contentTypeDefinitionInputReferenceViewSearchTermsItemMax),
            )
            .max(contentTypeDefinitionInputReferenceViewSearchTermsMax)
            .optional(),
        })
        .nullish(),
    })
    .nullish()
    .describe(
      "Reference config for a STRING type whose instances point at another TYPE's instances. Pass null to clear a stored config; omit to keep it.",
    ),
});

export type ContentTypeDefinitionInput = zod.input<typeof ContentTypeDefinitionInput>;
export type ContentTypeDefinitionInputOutput = zod.output<typeof ContentTypeDefinitionInput>;
